export const PORTAL_KEY = 'customer'
export const SESSION_STORAGE_KEY = 'portalSessionId'
